import React from 'react';
// import { withStyles } from '@material-ui/core/styles';
import { Grid as MuiGrid, RootRef } from '@material-ui/core';
import Paper from './Paper';
import createTree from '../../utils/createTree';
import ThemeProvider from '../../components/ThemeProvider';
import styled from 'styled-components/macro';

const StyledMuiItem = styled(MuiGrid)`
  position: relative;
`;

function Grid({
  // styling
  backgroundColor,
  color,
  corners,
  elevation,
  fullHeight,
  inline,
  marginBottom,
  overflow,
  padding,

  // breakpoints
  xs,
  sm,
  md,
  lg,
  xl,

  // refs for animations
  refCallback,

  // other props for MuiGrid
  spacing,
  items,
  children,
  ...props
}) {
  // props we pass to all grid items
  const passProps = {
    // styling
    backgroundColor,
    color,
    corners,
    elevation,
    fullHeight,
    inline,
    marginBottom,
    overflow: overflow || 'visible',
    padding,

    // breakpoints
    xs,
    sm,
    md,
    lg,
    xl,

    // refs for animations
    refCallback,
  };

  // remove undefined props before passing
  Object.keys(passProps).forEach(key => {
    if (passProps[key] === undefined) {
      delete passProps[key];
    }
  });

  // const GridTheme = 'theme' in props ? ThemeProvider : React.Fragment;

  const GridWithItems = (
    <MuiGrid
      {...props}
      className="grid"
      container
      spacing={spacing >= 0 ? spacing : 2}
    >
      {itemsPropToChildren(items, passProps)}
    </MuiGrid>
  );

  return 'theme' in props ? (
    <ThemeProvider theme={props.theme}>{GridWithItems}</ThemeProvider>
  ) : (
    GridWithItems
  );
}

function itemsPropToChildren(items, props) {
  return items
    .map((item, i) => {
      if (typeof item === 'string') {
        item = {
          content: item,
        };
      }

      const itemType = item.type;

      item = Object.assign(
        { type: Item, itemType, xs: 12, md: 6, itemKey: i, ...props },
        item
      );

      if (item.backgroundColor) {
        item.style = { backgroundColor: item.backgroundColor };
        delete item.backgroundColor;
      }

      if (!item.children) {
        item.children = [
          {
            type: 'Text',
            content: item.content,
          },
        ];
      }

      return item;
    })
    .map(createTree);
}

// TODO clean up the relationship with optional paper
class Item extends React.Component {
  render() {
    const {
      actions,
      backgroundColor,
      children,
      classes,
      color,
      corners,
      elevation,
      fullHeight,
      inline,
      itemKey,
      marginBottom,
      overflow,
      padding,
      refCallback,
      style,
      theme,
      ...itemProps
    } = this.props;

    const paperProps = {
      actions,
      backgroundColor,
      children,
      classes,
      color,
      corners,
      elevation: elevation || 0,
      // set `true` by default, unless explicitly false
      fullHeight: fullHeight === false ? false : true,
      inline,
      marginBottom: marginBottom || 0,
      overflow,
      padding,
      ref: refCallback ? refCallback(itemKey) : null,
      style,
      theme,
    };

    const ref = refCallback || (() => null);

    const TheItem = (
      <StyledMuiItem {...itemProps} item>
        <Paper {...paperProps}>{children.map(createTree)}</Paper>
      </StyledMuiItem>
    );

    return refCallback ? (
      <RootRef rootRef={ref(itemKey)}>{TheItem}</RootRef>
    ) : (
      TheItem
    );
  }
}

export default Grid;
